import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE_PROTECTED_KEYS: InjectionToken<string[]> = new InjectionToken<string[]>(
	'LOCAL_STORAGE_PROTECTED_KEYS',
	{
		providedIn: 'root',
		factory: () => [],
	}
);

export const SESSION_STORAGE_SYNC_SKIP_KEYS: InjectionToken<string[]> = new InjectionToken<string[]>(
	'SESSION_STORAGE_SYNC_SKIP_KEYS',
	{
		providedIn: 'root',
		factory: () => [],
	}
);
